import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatBubbleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.2006 13.416C15.6486 13.416 15.1956 12.969 15.1956 12.416C15.1956 11.863 15.6386 11.416 16.1916 11.416H16.2006C16.7526 11.416 17.2006 11.863 17.2006 12.416C17.2006 12.969 16.7526 13.416 16.2006 13.416ZM12.1916 13.416C11.6386 13.416 11.1866 12.969 11.1866 12.416C11.1866 11.863 11.6306 11.416 12.1826 11.416H12.1916C12.7436 11.416 13.1916 11.863 13.1916 12.416C13.1916 12.969 12.7436 13.416 12.1916 13.416ZM8.18264 13.416C7.63064 13.416 7.17864 12.969 7.17864 12.416C7.17864 11.863 7.62064 11.416 8.17364 11.416H8.18264C8.73464 11.416 9.18264 11.863 9.18264 12.416C9.18264 12.969 8.73464 13.416 8.18264 13.416ZM19.6766 4.57599C17.6956 2.59499 15.0586 1.50299 12.2526 1.50299C9.44664 1.50299 6.80964 2.59499 4.82864 4.57599C1.72664 7.67899 0.880633 12.441 2.70564 16.375C2.73864 16.537 2.64964 17.196 2.58564 17.678C2.34364 19.484 2.21964 20.81 2.83264 21.424C3.44464 22.037 4.76964 21.913 6.57564 21.67C7.05764 21.606 7.72464 21.52 7.82864 21.531C9.23464 22.182 10.7376 22.497 12.2296 22.497C14.9676 22.497 17.6696 21.435 19.6766 19.427C23.7696 15.332 23.7706 8.66999 19.6766 4.57599Z",
		fill: "currentColor"
	})
});
export default SvgChatBubbleFill;
